import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import {
  usePartner,
  usePartnerConfiguration,
} from 'src/modules/homeownerApp/hooks/usePartner/index';
import { useIsHomeownerWithoutPartner } from 'src/modules/homeownerApp/hooks/usePartner/useIsHomeownerWithoutPartner';

/**
 * Manufacturer CTA's cannot be shown to all users This hook manages the various
 * cases that control whether a manufacturer CTA can be shown.
 */
export const useShowManufacturerCTA = (): boolean => {
  const { isLoading } = usePartner();
  const { user } = useHomeownerAppContext();
  const { isHomeownerWithoutPartner } = useIsHomeownerWithoutPartner();
  const config = usePartnerConfiguration();

  // When a user exists and is not a homeowner, do not show the CTA
  if (user && !user.isHomeowner) {
    return false;
  }

  // A null config indicates partner configuration is still loading. If config
  // or partner is still loading, return false
  if (isLoading || !config) {
    return false;
  }

  if (isHomeownerWithoutPartner) {
    return true;
  }

  return !!config.showManufacturerCTA;
};
